<template>
  <div>
    <asc-dialog
      text="Add Airline Agreement"
      :width="500"
      :show-dialog="showDialog"
      primary-button-text="Save"
      :on-primary="onSaveClicked"
      :primary-available="validate"
      :on-close="onCloseDialog"
      :loading="buttonLoading"
    >
      <template v-if="showDialog">
        <asc-spinner-wrapper :loading="dialogLoading">
          <asc-airline-agreement-form
            :data="data"
            :airlines="airlines"
            :platforms="platforms"
            :agreements="agreements"
            @update="handleUpdatedFields"
          ></asc-airline-agreement-form>
          <template v-if="!validDateRange">
            <asc-validation-message
              class="asc-agreement-validation-message"
              message="Please enter a valid date range."
              :show="!validDateRange"
            ></asc-validation-message>
          </template>
        </asc-spinner-wrapper>
      </template>
    </asc-dialog>

    <div class="asc-agreement-confirm-dialog">
      <asc-dialog
        :show-dialog="showConfirmationDialog"
        text="Are you sure you want to submit?"
        :on-primary="onSubmitClicked"
        primary-button-text="Submit"
        :on-secondary="onCloseConfirmationDialog"
        secondary-button-text="Cancel"
      >
        You can't make changes to this agreement once submitted. Click submit
        below to proceed or cancel to continue editing.
      </asc-dialog>
    </div>
  </div>
</template>

<script>
import AscDialog from '@/components/atoms/AscDialog'
import AscAirlineAgreementForm from './AscAirlineAgreementForm'
import AscSpinnerWrapper from '@/components/atoms/AscSpinnerWrapper'
import AscValidationMessage from '@/components/atoms/AscValidationMessage'

export default {
  name: 'AscAirlineAgreementDialog',

  components: {
    AscDialog,
    AscAirlineAgreementForm,
    AscSpinnerWrapper,
    AscValidationMessage,
  },

  props: {
    onCloseDialog: {
      type: Function,
      default: () => {},
    },
    agreementData: {
      type: Object,
      default: () => {},
    },
    showDialog: {
      type: Boolean,
      default: false,
    },
    buttonLoading: {
      type: Boolean,
      default: false,
    },
    dialogLoading: {
      type: Boolean,
      default: false,
    },
    airlines: {
      type: Array,
      default: () => [],
    },
    platforms: {
      type: Array,
      default: () => [],
    },
    agreements: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      data: {},
      showConfirmationDialog: false,
    }
  },

  computed: {
    validate() {
      return (
        !!this.data.airlineId &&
        !!this.data.masterModelId &&
        !!this.data.masterModelId.length > 0 &&
        !!this.data.airlineAgreementTypeId &&
        !!this.data.fromDate &&
        !!this.data.toDate &&
        this.validDateRange
      )
    },
    validDateRange() {
      const endDate = new Date(this.data.toDate)
      const startDate = new Date(this.data?.fromDate)
      return !(startDate > endDate)
    },
  },

  watch: {
    agreementData: {
      immediate: true,
      handler() {
        this.data = {
          airlineId: null,
          masterModelId: null,
          airlineAgreementTypeId: null,
          fromDate: '',
          toDate: '',
          isBillable: true,
        }
      },
    },
  },

  methods: {
    handleUpdatedFields(data) {
      this.data = { ...data }
    },
    onSaveClicked() {
      this.showConfirmationDialog = true
    },
    onCloseConfirmationDialog() {
      this.showConfirmationDialog = false
    },
    onSubmitClicked() {
      this.showConfirmationDialog = false
      this.$emit('submitAgreement', this.data)
    },
  },
}
</script>

<style lang="scss">
.asc-agreement-confirm-dialog {
  .asc-dialog {
    .v-card__text {
      min-height: auto !important;
      padding: 16px 16px 19px !important;
    }
  }
}

.asc-agreement-validation-message {
  padding: 0 10px;
  position: relative;
  top: -20;
}
</style>
